<template>
  <vs-card>
    <div slot="header">Mensajes</div>

    <vs-table stripe :data="messages">
      <template slot="thead">
        <vs-th>Leyenda</vs-th>
        <vs-th>Tipo de leyenda</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="(message, index) in data" :key="index">
          <vs-td>{{message.leyenda}}</vs-td>
          <vs-td>{{message.tipoMensaje}}</vs-td>
        </vs-tr>
      </template>
    </vs-table>

  </vs-card>
</template>

<script>
export default {
  name: "ci-messages-table",
  props: ["messages"]
}
</script>

<style scoped>

</style>
